import { render, staticRenderFns } from "./ReturnabilityByServiceSubHeader.vue?vue&type=template&id=03852fb1&scoped=true"
import script from "./ReturnabilityByServiceSubHeader.vue?vue&type=script&lang=js"
export * from "./ReturnabilityByServiceSubHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03852fb1",
  null
  
)

export default component.exports